module.exports = __webpack_public_path__ + "static/img/sdown.654344ba.svg";